var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7150"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3323",
    cx: 85.5,
    cy: 85.5,
    r: 70.5,
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3324",
    d: "M168.657 89.9874C169.882 90.0536 170.932 89.1136 170.967 87.8869C171.502 68.7432 165.592 49.9708 154.188 34.5857C153.457 33.5999 152.058 33.4308 151.091 34.1869C150.125 34.943 149.957 36.3379 150.686 37.3247C161.43 51.862 167.007 69.5771 166.528 87.6474C166.495 88.874 167.432 89.9213 168.657 89.9874Z",
    fill: "#00C087",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.374 61.5048C118.904 61.028 118.345 60.6495 117.73 60.3912C117.114 60.133 116.454 60 115.787 60C115.12 60 114.459 60.133 113.844 60.3912C113.228 60.6495 112.669 61.028 112.2 61.5048L74.5624 99.4558L58.7497 83.4818C58.262 83.0075 57.6864 82.6345 57.0556 82.3842C56.4249 82.1339 55.7513 82.0111 55.0734 82.0229C54.3956 82.0347 53.7266 82.1809 53.1048 82.453C52.483 82.7252 51.9206 83.118 51.4495 83.609C50.9785 84.1 50.6081 84.6797 50.3595 85.3148C50.111 85.95 49.989 86.6283 50.0008 87.3109C50.0125 87.9935 50.1576 88.6671 50.4279 89.2932C50.6981 89.9194 51.0882 90.4858 51.5758 90.9601L70.9755 110.495C71.4451 110.972 72.0039 111.35 72.6195 111.609C73.2352 111.867 73.8955 112 74.5624 112C75.2293 112 75.8897 111.867 76.5053 111.609C77.1209 111.35 77.6797 110.972 78.1493 110.495L119.374 68.9831C119.886 68.5067 120.296 67.9285 120.576 67.285C120.855 66.6415 121 65.9465 121 65.2439C121 64.5414 120.855 63.8464 120.576 63.2029C120.296 62.5594 119.886 61.9812 119.374 61.5048V61.5048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3325",
    d: "M144.387 26.6135C145.254 25.7458 145.256 24.3366 144.366 23.4917C134.885 14.4913 123.466 7.7844 110.988 3.88743C109.817 3.52163 108.587 4.20959 108.252 5.39001C107.916 6.57043 108.603 7.79615 109.774 8.16362C121.524 11.8515 132.279 18.1689 141.223 26.6351C142.114 27.4787 143.519 27.4812 144.387 26.6135Z",
    fill: "#00C087",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3326",
    d: "M96.9813 3.01711C97.1505 1.80172 96.3025 0.676294 95.0832 0.538754C85.796 -0.508792 76.3998 -0.0265219 67.2687 1.96635C66.0698 2.22801 65.3416 3.43433 65.6343 4.62601C65.927 5.81769 67.1299 6.54329 68.3291 6.28334C76.9125 4.4228 85.7415 3.96965 94.4703 4.94162C95.6899 5.07743 96.8121 4.23249 96.9813 3.01711Z",
    fill: "#00C087",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3327",
    d: "M57.838 6.95026C57.4304 5.79283 56.1605 5.18218 55.0141 5.61972C51.4251 6.98946 47.9324 8.59952 44.5599 10.439C43.4826 11.0265 43.1222 12.3887 43.7376 13.4504C44.3529 14.512 45.711 14.871 46.7891 14.2849C49.9211 12.5824 53.162 11.0884 56.4907 9.81263C57.6365 9.37346 58.2456 8.10769 57.838 6.95026Z",
    fill: "#00C087",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3328",
    d: "M35.7902 18.6855C35.0577 17.701 33.6639 17.4943 32.6987 18.2521C31.8601 18.9106 31.0339 19.5847 30.2205 20.2741C29.2843 21.0674 29.207 22.4744 30.0244 23.3896C30.8418 24.3048 32.2444 24.3815 33.1817 23.5895C33.8949 22.9867 34.6186 22.3964 35.3522 21.8186C36.3163 21.0594 36.5226 19.67 35.7902 18.6855Z",
    fill: "#00C087",
    fillOpacity: 0.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ba78a17af782b30ec99ac10eed4ea16c.svg";
export { ForwardRef as ReactComponent };